import { createContext, useContext } from 'react';
import { MFE_URLS, URL_ROUTES } from 'adapters/constants';
import { URLType } from 'adapters/types';
import { useClient } from 'components/ClientProvider';

type ContextValue = URLType;

const URLsContext = createContext<ContextValue>(URL_ROUTES);

export function URLsProvider({
  children
}: {
  children: React.ReactNode;
}): React.JSX.Element {
  const client = useClient();
  const routes: URLType = client?.isMFE ? MFE_URLS : URL_ROUTES;
  return <URLsContext.Provider value={routes}>{children}</URLsContext.Provider>;
}

export const useURLs = (): ContextValue => useContext(URLsContext);
